module.exports = __webpack_public_path__ + "static/media/user-crown.2e6a1c26.svg";